import React, {
    ReactNode,
    createContext,
  } from "react";
  import useContact, { ContactType } from "./hooks/useContact";
  import type { ContactListFilters } from "../gateways/ContactsGateway";
  
  interface ContactContextProviderProps {
    children: ReactNode;
  }
  
  interface ContactContextData {
    getContactsByUserId: (page: number, filters?: ContactListFilters) => any;
    deleteContact: (id: string) => any;
    getContact: (id: string) => any;
    createContact: (contactData?: Partial<ContactType>) => any;
    updateContact: (contactData?: Partial<ContactType>) => any;
    setFormValuesContact: any;
    formValuesContact: ContactType;
    tableContacts: any[];
    totalContats: number;
    getContactByEmail: (email: string, userId: string) => any;
  }
  
  const initialState: ContactContextData = {
    getContactsByUserId: () => {},
    deleteContact: () => {},
    getContact: () => {},
    createContact: () => {},
    updateContact: () => {},
    setFormValuesContact: () => {},
    formValuesContact: {} as ContactType,
    tableContacts: [],
    totalContats: 0,
    getContactByEmail(){}
  };
  
  export const ContactContext = createContext<ContactContextData>(initialState);
  
  export default function ContactContextProvider({
    children,
  }: ContactContextProviderProps) {
    const {
        getContactsByUserId,
        deleteContact,
        createContact,
        updateContact,
        getContact,
        setFormValuesContact,
        formValuesContact,
        tableContacts,
        totalContats,
        getContactByEmail
    } = useContact();
  
    return (
      <ContactContext.Provider
        value={{
            getContactsByUserId,
            deleteContact,
            createContact,
            updateContact,
            getContact,
            setFormValuesContact,
            formValuesContact,
            tableContacts,
            totalContats,
            getContactByEmail
        }}
      >
        {children}
      </ContactContext.Provider>
    );
  }
  